/**
 * Lock collection + search product tiles to uniform 1024×1365 boxes.
 */
(function () {
  var TILE_ASPECT = 1024 / 1365;
  var TILE_PADDING = "calc(1365 / 1024 * 100%)";
  var body = document.body;
  if (!body) return;

  var isCollection = body.classList.contains("template-collection");
  var isSearch = body.classList.contains("template-search");
  if (!isCollection && !isSearch) return;

  function gridRoot() {
    if (isCollection) return document.querySelector(".collection-grid");
    return document.querySelector(".grid.grid--uniform");
  }

  function normalizeUniformGrid() {
    var grid = gridRoot();
    if (!grid) return;

    grid.querySelectorAll(".product-item__image-container").forEach(function (el) {
      el.style.removeProperty("max-width");
      el.style.setProperty("max-width", "none", "important");
      el.style.setProperty("width", "100%", "important");
      el.style.setProperty("margin", "0", "important");
    });

    grid.querySelectorAll(".product-item__image-wrapper").forEach(function (el) {
      el.style.removeProperty("padding-top");
      el.style.removeProperty("height");
      el.style.setProperty("position", "relative", "important");
      el.style.setProperty("height", "0", "important");
      el.style.setProperty("width", "100%", "important");
      el.style.setProperty("padding-top", TILE_PADDING, "important");
      el.style.setProperty("overflow", "hidden", "important");
    });

    grid.querySelectorAll(".product-item__image").forEach(function (img) {
      img.setAttribute("data-aspectratio", String(TILE_ASPECT));
      img.style.setProperty("position", "absolute", "important");
      img.style.setProperty("top", "0", "important");
      img.style.setProperty("left", "0", "important");
      img.style.setProperty("width", "100%", "important");
      img.style.setProperty("height", "100%", "important");
      img.style.setProperty("margin", "0", "important");
      img.style.setProperty("object-fit", "cover", "important");
      img.style.setProperty("object-position", "center center", "important");
    });
  }

  normalizeUniformGrid();
  document.addEventListener("DOMContentLoaded", normalizeUniformGrid);
  document.addEventListener("lazyloaded", normalizeUniformGrid, true);
  window.addEventListener("load", normalizeUniformGrid);
})();
